/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import gaLogger from 'src/utils/ga-logger';
import { makeHexCode } from 'src/components/common/helper';
import { V2ProgressBar } from './v2-progress-bar';

const ProgressBar: React.FC<any> = (props: any) => {
  const { secondaryColour, progressBarType } = props;

  const secondaryColorHexCode = makeHexCode(secondaryColour);

  const [progress, setProgress] = useState('6%');

  const getProgressWidth = () => {
    const scrollTop = document.body.scrollTop ? document.body.scrollTop : document.documentElement.scrollTop;
    const outerHeight = window.outerWidth < 768 ? window.outerHeight - document.documentElement.clientHeight : 0;
    return (
      ((scrollTop + outerHeight) / (document.documentElement.scrollHeight - document.documentElement.clientHeight)) *
      94 +
      6 +
      '%'
    );
  };

  const round = (num, precision) => {
    num = parseFloat(num);
    if (!precision) return num.toLocaleString();
    return (Math.round(num / precision) * precision).toLocaleString();
  };

  useEffect(() => {
    if (window) {
      let lastScrollTop = 0;
      window.addEventListener('scroll', () => {
        const scrolPercent = round(getProgressWidth(), 20);
        if (scrolPercent >= 20) {
          let scrollDirection = '';
          const st = window.pageYOffset || document.documentElement.scrollTop;
          if (st > lastScrollTop) {
            scrollDirection = 'SCROLL-DOWN';
          } else {
            scrollDirection = 'SCROLL-UP';
          }
          lastScrollTop = st <= 0 ? 0 : st;
          gaLogger.logGaWithMetrics('scroll', scrollDirection, scrolPercent);
        }

        setProgress(getProgressWidth());
      });

      window.addEventListener('onresize', () => {
        setProgress(getProgressWidth());
      });

      setProgress(getProgressWidth());
    }
  }, []);

  return (
    <div className="progress-bar-wrapper">
      {progressBarType === 'v2' ?
        <V2ProgressBar backgroundColor={secondaryColorHexCode} width={progress} /> :
        <div className='progress-bar' style={{ backgroundColor: secondaryColorHexCode, width: progress }}></div>
      }
    </div>
  );
};

export { ProgressBar };
